import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Login from '../views/Login'
import Welcome from '../views/Welcome'
import ProductDetails from '../views/ProductDetails'
import CustomerDetails from '../views/CustomerDetails'
const routes = [
    { path: '/login', name: 'login', component: Login },
    { path: '/', name: 'welcome', component: Welcome},
    { path: '/product', name: 'product', component: ProductDetails},
    { path: '/customer-details', name: 'checkout-customer-details', component: CustomerDetails},

]

const router = new Router({
    mode: 'history',
    base : '/',
    routes
})

function nextFactory(context,middleware,index) {
    const subsequentMiddleware = middleware[index]
    if(!subsequentMiddleware) return context.next
    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context,middleware,index + 1);
        subsequentMiddleware({...context,next : nextMiddleware})
    }
}


async function beforeEach(to, from, next){


    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]
        const context = {
            from,
            next,
            router,
            to
        }
        const nextMiddleware = nextFactory(context, middleware, 1)
        return middleware[0]({ ...context, next: nextMiddleware })
    }

    return next()

}
router.beforeEach(beforeEach)

export default router
